module.exports = __webpack_public_path__ + "img/grade13.99e8e639.png";